import Vue from "vue";

export default {
    getPackagingProject: async ({commit}, selectedProject) => {
        if (selectedProject) {
            let config = {
                method: 'get',
                url: Vue.prototype.$env.VUE_APP_API_URL + '/v3-provisioning/project-report-v3',
                headers: {
                    'Content-Type': 'application/json'
                },
                params: {id: selectedProject._id},
            };
            return await Vue.prototype.$http(config)
                .then((response) => {
                    console.log('Get project response: ', response)
                    if (response.status === 200) {
                        //commit('setAllProjects', response.data)
                        commit('setSelectedPackagingProject', response.data)
                    }
                    return response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });

        } else {
            commit('setSelectedPackagingProject', null)
        }
    },
    setQueryData: async ({commit}, queryData) => {
        commit('setQueryData', queryData)
    },
    setSelectedPackagingProject: async ({commit, dispatch}, selectedProject) => {
        if (selectedProject) {
            let config = {
                method: 'get',
                //url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/data-packaging-report',
                url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/data-packaging-per-site-report',
                headers: {
                    'Content-Type': 'application/json'
                },
                params: {projectId: selectedProject._id},
            };
            return await Vue.prototype.$http(config)
                .then(async (response) => {
                    console.log('Get data packaging response: ', response)
                    commit('setSelectedPackagingProject', response.data)
                    return response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });

        } else {
            commit('setSelectedPackagingProject', null)
            //commit('setSelectedVideoCalibration', null)
            commit('setSelectedPackagingDevice', null)
        }
    },
    preparePackagingData: async ({commit}, siteId) => {
        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/prepare-packaging-data',
            headers: {
                'Content-Type': 'application/json'
            },
            data: {siteId: siteId}
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Prepare packaging data response: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                } else if (response.status === 200) {
                    console.log('Success!!!')
                    commit('updatePackagingForDevice', response.data)
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    extractImagesForSite: async ({commit}, payload) => {
        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/extract-dtp-images',
            headers: {
                'Content-Type': 'application/json'
            },
            data: payload
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Extract dtp images response: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                } else if (response.status === 200) {
                    console.log('Success!!!')
                    //commit('updatePackagingForDevice', response.data)
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    submitData: async ({commit}, payload) => {
        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/submit-dtp-data',
            headers: {
                'Content-Type': 'application/json'
            },
            data: payload
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Submit data response: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                } else if (response.status === 200) {
                    console.log('Success!!!')
                    //commit('updatePackagingForDevice', response.data)
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },

    setSelectedPackagingDevice: async ({commit}, packagingDevice) => {
        if (packagingDevice) {
            commit('setSelectedPackagingDevice', packagingDevice)
        } else {
            commit('setSelectedPackagingDevice', null)
        }
    },
    setDpLegendSelection: async ({commit}, selection) => {
        commit('setDpLegendSelection', selection)
    },
    getBulkFilesUrls: async ({commit}, files) => {

        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/file-bulk-presigned-urls',
            headers: {
                'Content-Type': 'application/json'
            },
            data: {files: files}
        };


        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Video bulk response: ', response.data)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });

    },
}

